export enum VtmnButtonSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  STRETCHED = 'stretched',
  RESPONSIVE = 'responsive',
}
